export default __webpack_public_path__ + "static/media/avatarB6.20f02372.png";